import { Component, OnInit } from '@angular/core';
import { Global } from '../../../../../app.global';

import {
  RadioQuestionModel,
  SelectQuestionModel,
  ExplainQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { PermitCustomCopy } from '../../../helper/textcopy/policies.text';
import { AdminService } from '../../../../../layouts/services/admin.service';
import { CustomPermitModel } from '../../../../../layouts/viewmodels/custom-permit.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'permit-custom-policy',
  templateUrl: './permit-custom.component.html',
  styleUrls: ['./permit-custom.component.scss'],
})
export class PermitCustomComponent implements OnInit {
  textCopy = PermitCustomCopy;
  customPermits: Array<CustomPermitModel> = [];
  selectedCustomPermit = new CustomPermitModel();
  displayedWithClock = new RadioQuestionModel();
  existingPermits = [];
  reconsider = new RadioQuestionModel();
  failDisplay = new SelectQuestionModel();
  explain = new ExplainQuestionModel();
  customPermitsIds = [];
  customPermitsNames = [];

  singularNameError = '';
  pluralNameError = '';
  sourceReasonIdError = '';
  generalError = '';
  customPermitMessage = '';
  customPermitSuccess = false;
  customPermitDeleteMessage = '';
  customPermitDeleteSuccess = false;
  isCustomPermitsLoading = false;

  constructor(public global: Global, private adminService: AdminService) {}

  ngOnInit() {
    this.setDisplayedWithClockQuestion();
    this.setReconsiderQuestion();
    this.setFailDisplayQuestion();
    this.setExplainQuestion();

    this.setExistimgPermits();
    this.setCustomPermits();
  }

  setCustomPermits() {
    this.isCustomPermitsLoading = true;
    this.customPermits = [];
    this.adminService.getCustomPermits().subscribe(
      (result) => {
        if (result) {
          this.customPermits = result;
          this.setCustomPermitsInitDat();
          this.isCustomPermitsLoading = false;
        }
      },
      (error) => {
        console.log('Something went wrong getting the custom permits.');
        this.isCustomPermitsLoading = false;
      }
    );
  }
  refreshCustomPermits() {
    this.setCustomPermits();
    this.selectedCustomPermit = new CustomPermitModel();
    this.selectedCustomPermit.id = '1';
    this.selectedCustomPermit.clock = 'n';
  }

  setCustomPermitsInitDat() {
    this.customPermitsIds = [];
    this.customPermitsNames = [];
    this.customPermits.forEach((customPermit) => {
      this.customPermitsIds.push(customPermit.id);
      this.customPermitsNames.push(customPermit.singularName);
    });
  }

  onCustomPermitChange(value) {
    this.customPermitDeleteMessage = '';
    if (value === '1') {
      this.selectedCustomPermit = new CustomPermitModel();
      this.selectedCustomPermit.id = '1';
      this.selectedCustomPermit.clock = 'n';
      return;
    }
    this.customPermits.forEach((customPermit) => {
      if (customPermit.id.toString() === value) {
        this.selectedCustomPermit = customPermit;
      }
    });
  }

  setDisplayedWithClockQuestion() {
    this.displayedWithClock.data = {
      title: this.textCopy.displayedText,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'no', value: 'n' },
      ],
    };
    this.selectedCustomPermit.clock = 'n';
  }
  onDisplayedWithClockSelected(answerValue) {
    this.selectedCustomPermit.clock = answerValue;
  }

  setExistimgPermits() {
    this.existingPermits = [
      {
        id: '551',
        text: 'business',
        checklist: `<ul>
        <li>valid for the zone the vehicle was in</li>
        <li>valid for the vehicle (ie permit registration matches vehicle registration)</li>
        <li>valid on the date the PCN was issued.</li>
        </ul>`,
      },
      {
        id: '1129',
        text: 'contract',
        checklist: `<ul>
        <li>valid for the street/area/zone the vehicle was in</li>
        <li>valid for the bay number the vehicle was in</li>
        <li>valid on the date the PCN was issued.</li>
        </ul>`,
      },
      {
        id: '560',
        text: "doctor's",
        checklist: `<ul>
        <li>valid for the bay the vehicle was in</li>
        <li>valid for the vehicle (ie permit registration matches vehicle registration)</li>
        <li>valid on the date the PCN was issued.</li>
        </ul>`,
      },
      {
        id: '569',
        text: "market trader's",
        checklist: `<ul>
        <li>valid for the bay and individual space the vehicle was in;</li>
        <li>valid for the vehicle (ie permit registration matches vehicle registration)</li>
        <li>valid on the date the PCN was issued.</li>
        </ul>`,
      },
      {
        id: '587',
        text: "resident's",
        checklist: `<ul>
        <li>valid for the zone the vehicle was in;</li>
        <li>valid for the vehicle (ie permit registration matches vehicle registration)</li>
        <li>valid on the date the PCN was issued.</li>
        </ul>`,
      },
      {
        id: '1130',
        text: 'season ticket',
        checklist: `<ul>
        <li>valid for the car park the vehicle was in;</li>
        <li>valid for the vehicle (ie permit registration matches vehicle registration)</li>
        <li>valid on the date the PCN was issued.</li>
        </ul>`,
      },
      {
        id: '1128',
        text: "visitor's",
        checklist: `<ul>
        <li>valid for the zone the vehicle was in;</li>
        <li>valid for the vehicle (ie permit registration matches vehicle registration)</li>
        <li>valid on the date the PCN was issued.</li>
        </ul>`,
      },
    ];
  }

  getPermitChecklistText() {
    let text = '';
    this.existingPermits.forEach((existingPermit) => {
      if (existingPermit.id === this.selectedCustomPermit.sourceReasonId) {
        text = existingPermit.checklist;
      }
    });
    return text;
  }

  isCustomPermitSelected() {
    return this.selectedCustomPermit.id !== '0' && this.selectedCustomPermit.id !== '1';
  }

  deleteCustomPermit() {
    if (!this.isCustomPermitSelected()) {
      return;
    }
    this.customPermitDeleteMessage = '';
    const permitIdIndex = this.customPermitsIds.indexOf(this.selectedCustomPermit.id);
    const permitOldName = this.customPermitsNames[permitIdIndex];
    this.adminService
      .deleteCustomPermit(parseInt(this.selectedCustomPermit.id, 10), permitOldName)
      .subscribe(
        (result) => {
          console.log(result);
          this.customPermitDeleteSuccess = result.success;
          this.customPermitDeleteMessage = result.message;
          console.log(this.customPermitDeleteMessage);
          this.setCustomPermits();
          this.selectedCustomPermit = new CustomPermitModel();
          this.selectedCustomPermit.id = '1';
        },
        (error) => {
          console.log(error);
          this.customPermitDeleteSuccess = false;
          this.customPermitDeleteMessage = 'Something went wrong. Please try again.';
        }
      );
  }

  setReconsiderQuestion() {
    this.reconsider.data = {
      title: this.textCopy.reconsiderText,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'yes – provided it was displayed (even if it was wrongly displayed)', value: 'd' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onReconsiderSelected(answerValue) {
    this.selectedCustomPermit.reconsider = answerValue;
  }

  setFailDisplayQuestion() {
    this.failDisplay.data = {
      title: this.textCopy.failTitle,
      answers: [
        { id: '0', value: '1' },
        { id: '1', value: '2' },
        { id: '2', value: '3' },
      ],
    };
  }
  onFailDisplaySelected(answerValue) {
    this.selectedCustomPermit.goodwillCancellations = answerValue;
  }

  setExplainQuestion() {
    this.explain = {
      data: {
        title: this.textCopy.explainTitle,
        includeTitle: false,
        name: 'for this permit',
        validList: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        selectedItem: '3',
        exampleItem: 'Custom permits',
      },
      active: true,
      valueSelected: '1',
      validationSelected: '9',
      validationText: 'text',
    };
  }
  onExplainSelected(answerValue) {
    this.selectedCustomPermit.misuseOption = answerValue.answerSelected;
    this.selectedCustomPermit.signpostOption = answerValue.validationSelected;
    this.selectedCustomPermit.myOwnExplanation = answerValue.validationText;
  }

  submitCustomPermit() {
    if (this.selectedCustomPermit.id === '0') {
      return;
    }
    this.customPermitDeleteMessage = '';
    this.generalError = '';
    if (!this.isNewPermitValid()) {
      this.generalError = 'Please fix the fields and try again.';
      return;
    }
    this.customPermitMessage = '';
    if (this.selectedCustomPermit.id === '1') {
      // add new permit
      console.log('Add custom permit');
      this.adminService.addCustomPermit(this.selectedCustomPermit).subscribe(
        (result) => {
          console.log(result);
          this.customPermitSuccess = result.success;
          this.customPermitMessage = result.message;
          // if (result.success) {
          //  this.selectedCustomPermit.id = '000' + this.customPermits.length.toString();
          //  this.customPermits.push(this.selectedCustomPermit);
          // }
          this.refreshCustomPermits();
        },
        (error) => {
          this.customPermitSuccess = false;
          this.customPermitMessage = 'Something went wrong. Please try again.';
        }
      );
    } else {
      // update existing permit
      const permitIdIndex = this.customPermitsIds.indexOf(this.selectedCustomPermit.id);
      const permitOldName = this.customPermitsNames[permitIdIndex];
      this.adminService.updateCustomPermit(this.selectedCustomPermit, permitOldName).subscribe(
        (result) => {
          this.customPermitSuccess = result.success;
          this.customPermitMessage = result.message;
          if (result.success) {
            this.setCustomPermits();
            this.onCustomPermitChange('1');
          }
        },
        (error) => {
          this.customPermitSuccess = false;
          this.customPermitMessage = 'Something went wrong. Please try again.';
        }
      );
    }
  }

  isNewPermitValid() {
    this.singularNameError = '';
    this.pluralNameError = '';
    this.sourceReasonIdError = '';
    if (this.selectedCustomPermit.singularName.length === 0) {
      this.singularNameError = 'Singular name is required.';
      return false;
    } else if (this.selectedCustomPermit.pluralName.length === 0) {
      this.pluralNameError = 'Plural name is required.';
      return false;
    } else if (this.selectedCustomPermit.sourceReasonId === '0') {
      this.sourceReasonIdError = 'Please select a permit.';
      return false;
    }
    return true;
  }
}
